import {
  GroupsApi,
  ReportingMelcoMachineStatisticsModelsGroupListItem,
  useAPIQuery,
  useTable,
} from "melco-shared-logic";
import isEmpty from "lodash-es/isEmpty";
import { useTableErrorComponent } from "../table/useTableErrorComponent";

export const useMachineGroups = () => {
  const {
    onTableConfigChange,
    pagination,
    setTotal,
    filters,
    sorter,
    currentPage,
    pageSize,
    sortBy,
    searchQuery,
    searchQueryChange,
  } = useTable<ReportingMelcoMachineStatisticsModelsGroupListItem>({
    pageSizeOptions: [10, 20],
    pageSize: 10,
  });

  const query = useAPIQuery(
    GroupsApi,
    ["groups", currentPage, pageSize, filters, sortBy(), searchQuery],
    async (api: GroupsApi) => {
      const response = await api.statisticsGroupsSearch({
        offset: (currentPage - 1) * pageSize,
        limit: pageSize,
        sortBy: sortBy(),
        searchText: !isEmpty(searchQuery) ? searchQuery : undefined,
      });

      setTotal(response.total);

      return response.list;
    },
    {
      queryOptions: {
        keepPreviousData: true,
      },
    }
  );

  const errorComponent = useTableErrorComponent(query.error, query.refetch);

  return {
    onTableConfigChange,
    pagination,
    setTotal,
    filters,
    sorter,
    searchQuery,
    searchQueryChange,
    errorComponent,

    ...query,
  };
};
